import { Box, styled } from '@mui/material';

interface LoaderProps {
  type?: 'absolute' | 'static';
}

const PREFIX = 'CC-Loader';
export const loaderClasses = {
  root: `${PREFIX}-root`,
  absolute: `${PREFIX}-absolute`,
  loader: `${PREFIX}-loader`,
  span: `${PREFIX}-span`,
} as const;

type RootProps = {
  type: 'absolute' | 'static';
};

const Root = styled(Box, {
  name: PREFIX,
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root,
  shouldForwardProp: prop => prop !== 'type',
})<RootProps>({
  [`&.${loaderClasses.root}`]: {
    position: 'relative',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  [`&.${loaderClasses.absolute}`]: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
  },

  [`& .${loaderClasses.loader}`]: {
    width: '35px',
    height: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  [`& .${loaderClasses.span}`]: {
    display: 'inline-block',
    width: '5px',
    height: '20px',
    backgroundColor: '#ddd',

    '&:nth-of-type(1)': {
      animation: 'loaderGrow 1s ease-in-out infinite',
    },

    '&:nth-of-type(2)': {
      animation: 'loaderGrow 1s ease-in-out 0.15s infinite',
    },

    '&:nth-of-type(3)': {
      animation: 'loaderGrow 1s ease-in-out 0.3s infinite',
    },

    '&:nth-of-type(4)': {
      animation: 'loaderGrow 1s ease-in-out 0.45s infinite',
    },
  },

  '@keyframes loaderGrow': {
    '0%, 100%': {
      transform: 'scaleY(1)',
    },
    '50%': {
      transform: 'scaleY(1.8)',
    },
  },
});

export const Loader = ({ type = 'absolute' }: LoaderProps) => {
  const rootClassName = `${loaderClasses.root}${type === 'absolute' ? ` ${loaderClasses.absolute}` : ''}`;

  return (
    <Root className={rootClassName} type={type}>
      <div className={loaderClasses.loader}>
        <span className={loaderClasses.span} />
        <span className={loaderClasses.span} />
        <span className={loaderClasses.span} />
        <span className={loaderClasses.span} />
      </div>
    </Root>
  );
};
